export const m3l2Solution = `%lang starknet

// What is really neat with implicit arguments is that they are returned implicitly by any function using them
// This is a very powerful feature of the language since it helps with readability, letting the developer omit
// implicit arguments in the subsequent function calls.

// You change the function signature!
func black_box{secret : felt}() -> () {
    // do not modify code on this line or above

    // TODO: implement the "black_box" function body to make the test pass
    let secret = 'very secret!';
    return ();
}

// do not modify code on this line or below

@external
func test_secret_change{syscall_ptr : felt*}() {
    let secret = 'no so secret';
    with secret {
        black_box();
        assert secret = 'very secret!';
    }

    return ();
}`;
